import { Button } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import { Icon } from "../../components/Icon";
import { P } from "../../components/Typography";

// from JourneyRightMenu
export const EmptyActionCardContent = ({
  iconName = "RocketLaunch",
  title,
  perex,
  button,
  extra,
  sx = {},
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 3,
        px: 3,
        py: 5,
        height: "100%",
        ...sx,
      }}
    >
      {iconName && (
        <Avatar sx={{ bgcolor: "#F9FAFB", width: 100, height: 100 }}>
          <Avatar sx={{ bgcolor: "#EAECF0", width: 60, height: 60 }}>
            <Icon name={iconName} sx={{ color: "#667085" }} />
          </Avatar>
        </Avatar>
      )}
      <Box sx={{ textAlign: "center", flex: 1 }}>
        {title && (
          <P emphasized sx={{ mb: 0.5 }}>
            {title}
          </P>
        )}
        {perex && <P>{perex}</P>}
      </Box>
      {button && <Button {...button} />}
      {extra}
    </Box>
  );
};
